import './index.less';
import React from 'react';
import Swiper from '../swiper/swiper.jsx';

class TeacherList extends React.Component{
  
  next = () => {
    this.refs.swiper.next();
  }

  prev = () => {
    this.refs.swiper.prev();
  }

  render(){
    const { teacherList, teacher, selectTec } = this.props;
    return (
      <div className='teacherList'>
        <div className='teacherList-left' onClick={() => this.prev()}></div>
        <Swiper ref='swiper' selectTec={selectTec} teacherList={teacherList} teacher={teacher}/>
        <div className='teacherList-right' onClick={() => this.next()}></div>
      </div>
    )
  }
}

export default TeacherList


// WEBPACK FOOTER //
// ./src/components/teacherList/teacherList.jsx